var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsdtBrand = function SvgUsdtBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.965 15.08v-2.368h5.418v-3.61h-14.75v3.61h5.417v2.366c-4.403.202-7.714 1.075-7.714 2.12 0 1.044 3.311 1.916 7.714 2.119v7.587h3.915v-7.589c4.396-.202 7.7-1.074 7.7-2.117 0-1.044-3.304-1.916-7.7-2.119m0 3.59v.002c3.883-.172 6.78-.848 6.78-1.658s-2.897-1.486-6.78-1.66V18c-.113.01-.718.06-1.926.06-1.007 0-1.735-.043-1.99-.06v-2.646c-3.89.174-6.793.851-6.793 1.66 0 .811 2.903 1.488 6.794 1.66v-.003c.25.012.961.042 1.972.042 1.266 0 1.833-.034 1.943-.042",
    clipRule: "evenodd"
  })));
};
export default SvgUsdtBrand;